import { AxiosRequestConfig } from 'axios'
import {
  Session as Data,
  SessionCollection as Collection,
  SessionStatus,
  SessionLogout,
} from '@/typings/api/Session'
import { User } from '@/typings/api/User'
import {
  BaseApiResponse as BR,
} from '@/typings/common'

import { BaseApiAuth } from '@/api/BaseApiAuth'


export class AgpSessionsApi extends BaseApiAuth<Data, Collection> {
  protected readonly endpoint = 'agp/sessions';

  public getUserStatus(userId: User['id'], params?: unknown, config: AxiosRequestConfig = {}) {
    const path = `${userId}/status/`
    const [url] = this.getUrl(path)
    return this.request<unknown, BR<SessionStatus>>('GET', url, { params, ...config })
  }

  public logout(id: Data['id'], params?: unknown, config: AxiosRequestConfig = {}) {
    const path = `${id}/logout/`
    const [url] = this.getUrl(path)
    return this.request<unknown, BR<SessionLogout>>('POST', url, { params, ...config })
  }
}
